var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10302",
    "data-name": "Group 10302",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 66.018,
    viewBox: "0 0 60 66.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4096",
    "data-name": "Rectangle 4096",
    width: 60,
    height: 66.018,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10301",
    "data-name": "Group 10301",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44433",
    "data-name": "Path 44433",
    d: "M20.593,58.6A36.4,36.4,0,0,1,10.8,53.036,28.258,28.258,0,0,1,.519,35.512C-1.3,24.87,1.639,15.6,9.565,8.081A27.911,27.911,0,0,1,23.763.642c10.892-2.052,20.292.8,28.042,8.81a27.93,27.93,0,0,1,7.819,15.625A29.573,29.573,0,0,1,53.112,49.1a33.121,33.121,0,0,1-12.3,8.934,1.431,1.431,0,0,1-.7.226c-.214-.034-.573-.3-.558-.432a16.452,16.452,0,0,1,.518-3.019,2.22,2.22,0,0,1,1.115-1.031A26.631,26.631,0,0,0,55.561,36.035a23.261,23.261,0,0,0,.555-6.2C55.872,18.3,50.073,10.458,39.755,5.77c-4.03-1.831-8.337-1.962-12.678-1.645-9.545.7-19.71,8.417-22.459,19.828a27.424,27.424,0,0,0-.539,7.531c.449,10.253,5.805,17.388,14.588,22.2a2.7,2.7,0,0,1,1.692,2.253c.065.813.143,1.625.235,2.661",
    transform: "translate(-0.001 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44434",
    "data-name": "Path 44434",
    d: "M68.7,96.061c-5.516-1.72-10.106-12-8.985-19.923,1.225-8.66,9.622-16.149,18.216-16.687A20.311,20.311,0,0,1,99.382,75.7c1.558,8.054-2.392,16.665-8.876,20.481,0-1.49-.049-2.86.034-4.222.021-.347.437-.689.712-1a18.052,18.052,0,0,0,4.451-8.9c1.477-8.078-4.176-16.478-12.233-18.38A16.359,16.359,0,0,0,63.811,75.9a16.094,16.094,0,0,0,3.363,14,1.427,1.427,0,0,0,.215.254c2.05,1.623,1.383,3.8,1.308,5.911",
    transform: "translate(-49.583 -49.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44435",
    "data-name": "Path 44435",
    d: "M134.581,230.943c0-.473,0-.945,0-1.418a4.778,4.778,0,0,1,3.341-4.861,11.108,11.108,0,0,1,8.061.007,4.615,4.615,0,0,1,3.283,4.8c-.207,3.849-.5,7.7-.9,11.531-.264,2.476-.775,4.928-1.229,7.381-.821,4.439-6.046,5.014-8.7,2.932a4.729,4.729,0,0,1-1.478-2.42c-.553-2.142-.891-4.34-1.284-6.52-.177-.982-.307-1.975-.407-2.969-.286-2.816-.546-5.635-.816-8.453l.138-.012",
    transform: "translate(-111.956 -186.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44436",
    "data-name": "Path 44436",
    d: "M145,123.531c4.185-.18,7,3.884,6.958,7.043a6.977,6.977,0,0,1-7.091,6.7A6.874,6.874,0,1,1,145,123.531",
    transform: "translate(-114.955 -102.865)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.129e9a4b74dd7fe2fff758e9c9c3de69.svg";
export { ForwardRef as ReactComponent };